import React from 'react'
import { useSelector } from 'react-redux'
import { withMapInitialized } from '../../map/map.utils'
import { isCoords } from '../../utils/location'
import ArrivalMarker from './ArrivalMarker'
import DepartureMarker from './DepartureMarker'
import { selectStepsCoordinates } from './steps.selectors'

const StepsMarkers = () => {
  const { departure, arrival, stops } = useSelector(selectStepsCoordinates)

  return (
    <>
      {isCoords(departure) && <DepartureMarker coords={departure} />}
      {stops.map(
        (step, index) =>
          isCoords(step) && (
            <DepartureMarker key={`${step.lat}-${step.lng}`} coords={step} step={true} stepIdx={index + 1} />
          )
      )}
      {isCoords(arrival) && <ArrivalMarker coords={arrival} />}
    </>
  )
}

// webpack:BrowserOnly
export default withMapInitialized(StepsMarkers)
